
<template>
  <div :class="{ 'formulate-input-element  formulate-input-element--text formulate-input-element--autocomplete' : true, 'is-loading': isLoading }"
    :data-type="context.type"
  >
    <!-- //  ( this.isLoading ? ' is-loading' : '') -->
    <!-- v-bind="context.attributes" -->
    <!-- @blur="context.blurHandler" -->

    <!-- TODO - change key's to field_name___locatio-key e.g vehicle_confirm_park_address_full, vehicle_confirm_park_address_linz_id -->
        <vue-autosuggest
            ref="autocomplete"
            v-model="autocompleteSearch.query"
            :suggestions="autocompleteSearch.suggestions"
            :inputProps="autocompleteSearch.inputProps"
            :getSuggestionValue="getSuggestionValue"
            @input="onSearchInputChange"
            @selected="onSelected"
        >
            <template slot-scope="{suggestion}">
                <!-- TODO - apply bold characters based on the query value address_full value  -->
                <div v-html="highlightResult(suggestion.item.address_full)"></div>
            </template>
        </vue-autosuggest>
        <SpinnerSvg v-if="!situationIsDisabled" class="loader" />
        <div class="field mt-2" :class="{'mb-0' : !situationIsDisabled }">
          <a v-on:click="situationIsDisabled = !situationIsDisabled">{{ situationIsDisabled ? "Cancel" : "Can't find your address?" }}</a>
        </div>

        <div :class="{ 'columns': 'columns', 'is-multiline': 'is-multiline', 'is-hidden': !situationIsDisabled}">
          <div class="column is-half is-full-mobile">
            <label>Flat/Unit (Optional)
              <input class="mt-1" :name="context.name + '_flat_unit'" v-model="context.model[context.name + '_flat_unit']" type="text" @input="onInputChange" placeholder="e.g. Flat 1" />
            </label>
          </div>
          <div class="column is-half is-full-mobile">
            <label>Street Number
              <input class="mt-1" :name="context.name + '_street_number'" v-model="context.model[context.name + '_street_number']" type="text" @input="onInputChange" placeholder="e.g. 21A" />
            </label>
          </div>
          <div class="column is-full">
            <label>Street Name
            <vue-autosuggest
              class="mt-1"
              ref="autocomplete_street"
              v-model="autocompleteStreet.query"
              :suggestions="autocompleteStreet.suggestions"
              :inputProps="autocompleteStreet.inputProps"
              :getSuggestionValue="getSuggestionStreetValue"
              @input="onStreetInputChange"
              @selected="onStreetSelected"
          >
              <template slot-scope="{suggestion}">
                  <!-- TODO - apply bold characters based on the query value address_full value  -->
                  <div v-html="highlightResult(suggestion.item.address_road_suburb_region)"></div>
              </template>
            </vue-autosuggest>
            <SpinnerSvg class="loader" />
            </label>

          </div>
          <div class="column is-full" :class="{ 'is-hidden': !context.model[context.name + '_displayed_address'] }">
            <label class="mb-1">Full home address of the car</label>
            <div :name="context.name + '_full_address'" >{{ context.model[context.name + '_displayed_address'] }}</div>

            <!-- <div :name="context.name + '_full_address'" >{{ context.model[context.name + '_displayed_address'] }}</div> -->
          </div>
        </div>
        <div class="mt-4 formulate-form-errors" v-for="error in errors" :key="error.id">{{ error }}</div>

      <!-- <div v-if="selected" style="margin-top: 10px;">
        You have selected:
        <code>
          <pre>{{JSON.stringify(selected, null, 4)}}</pre>
        </code>
      </div> -->


    </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest';

const locatioUrl = 'https://geocode.initio.co.nz/api/v1/public/search'
const locatioStreetUrl = 'https://geocode.initio.co.nz/api/v1/public/searchstreet'
const locatioNearUrl = 'https://geocode.initio.co.nz/api/v1/public/nearaddress'

import axios from 'axios'

import SpinnerSvg from '@/components/partials/SpinnerSvg.vue'
import {mapGetters} from "vuex";

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default {
  components: {
    VueAutosuggest,
    SpinnerSvg
  },
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      autocompleteSearch: {
        query: this.getSearchQuery(),
        results: [],
        timeout: null,
        selected: null,
        debounceMilliseconds: 400,
        inputProps: {
          id: "autosuggest__input",
          placeholder: 'Type and select the address from the dropdown',
          class: "form-control",
          disabled: this.getAlternativeInput(),
          autocomplete: 'off',
        },
        suggestions: [],
      },
      autocompleteStreet: {
        query: this.getStreetQuery(),
        results: [],
        timeout: null,
        selected: null,
        debounceMilliseconds: 400,
        inputProps: {
          id: "autosuggest_street__input",
          placeholder: 'Type and select the street from the dropdown',
          class: "form-control",
          disabled: false
        },
        suggestions: [],
      },
      nearAddress: {
        debounceMilliseconds: 400,
        timeout: null,
        address: null,
        suggestions: null,
        selected: null
      },
      errors: [],
      isLoading: false,
      situationIsDisabled: this.getAlternativeInput()
    }
  },
  watch: {
    model () {
    },
    situationIsDisabled: function (isDisabled) {
      this.autocompleteSearch.inputProps.disabled = isDisabled;

      clearTimeout(this.timeout); // stop loading

      if (isDisabled) {
        const context_value = { 
          [`${this.context.name}_cant_find`]: true,
        };
        this.context.model = context_value;

        this.$set(this.autocompleteSearch.inputProps, 'placeholder', '');
        this.$set(this.autocompleteSearch, 'selected', null);
        this.$set(this.autocompleteSearch, 'query', ''); // clear first input
        this.$set(this.autocompleteStreet.inputProps, 'class', this.autocompleteStreet.inputProps.class.replace(' valid',''));

      } else {
        const context_value = { 
          
        };
        this.context.model = context_value;

        this.$set(this.autocompleteSearch.inputProps, 'placeholder', 'Type and select the address from the dropdown');

        this.$delete(this.context.model,`${this.context.name}_cant_find`);
        this.$delete(this.context.model,`${this.context.name}_street_address`);
        this.$delete(this.context.model,`${this.context.name}_street_locatio_id`);
        this.$delete(this.context.model,`${this.context.name}_street_number`);
        this.$delete(this.context.model,`${this.context.name}_flat_unit`);
        
        this.$set(this.autocompleteStreet, 'query', ''); // clear first input
        this.$set(this.autocompleteStreet.inputProps, 'class', this.autocompleteStreet.inputProps.class.replace(' valid',''));
      }
    },
  },
  computed: {
    model () {
      return this.context.model
    },
    containerClass() {
        return `formulate-input-element  formulate-input-element--text formulate-input-element--${this.context.type}`
    },
    ...mapGetters({
      answers: 'flattenedAnswers',
      currentSession: 'currentSession',
    }),
  },
  beforeMount(){
    // address from answers
    // this.answers[this.currentSession.activeStepKey][this.context.name + '_full_address'];

    // address from model

  },
  methods: {
    highlightResult(text){
        return text.replace(new RegExp(this.autocompleteSearch.query, "gi"), (match) => `<strong>${match}</strong>`);
    },
    getSearchQuery(){
        return this.context.model && this.context.model[`${this.context.name}_full_address`] ? this.context.model[`${this.context.name}_full_address`] : '';
    },
    getStreetQuery(){
        return this.context.model && this.context.model[`${this.context.name}_street_address`] ? this.context.model[`${this.context.name}_street_address`] : '';
    },
    // getNearAddressQuery(){
    //     let context = this.nearAddress;
    //     context.address = context.model[`${context.name}_displayed_address`] ?? null;
    //     // this.nearAddress.address = this.context.model[`${this.context.name}_displayed_address`] ?? null;


    //     return this.context.model && this.context.model[`${this.context.name}_displayed_address`] ? this.context.model[`${this.context.name}_displayed_address`] : '';
    // },
    getAlternativeInput() {
      return this.context.model[`${this.context.name}_cant_find`] ? true : false
    },
    onSearchInputChange() {

      let context = this.autocompleteSearch;

      this.$delete(this.context.model, `${this.context.name}_full_address`);
      this.$delete(this.context.model, `${this.context.name}_locatio_id`);

      this.isLoading = false;
      const query = this.autocompleteSearch.query;
      context.model = {};
      
      clearTimeout(context.timeout);
      context.timeout = setTimeout(() => {

        let context = this.autocompleteSearch;

        this.isLoading = true;
        this.errors = [];

        const locatioPromise = axios.post(`${locatioUrl}`, { address: query});
        Promise.all([locatioPromise]).then(response => {
          context.suggestions = [];
          context.selected = null;
          context.suggestions = [ {data: response[0].data.results}];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.error(error, "Problem loading locatio, front-end show should nice client error");
          this.errors = [ "Unfortunately, we are having technical difficulties while looking up your address. You can try refreshing the page and trying again, or try again later." ];
        });
      }, context.debounceMilliseconds);
    },
    onStreetInputChange() {

      let context = this.autocompleteStreet;

      this.isLoading = false;
      const query = this.autocompleteStreet.query;

      // remove valid class
      this.$set(context.inputProps, 'class', context.inputProps.class.replace(' valid',''));

      // const context_value = {
      //   [`${this.context.name}_street_address`]: false,
      //   [`${this.context.name}_street_locatio_id`] : false,
      // };
      this.$delete(this.context.model, `${this.context.name}_street_address`);
      this.$delete(this.context.model, `${this.context.name}_street_locatio_id`);

      this.getAlternativeAddress();

      // this.context.model = Object.assign(this.context.model, context_value);
      
      clearTimeout(context.timeout);
      context.timeout = setTimeout(() => {

        let context = this.autocompleteStreet;

        this.isLoading = true;
        this.errors = [];

        const locatioPromise = axios.post(`${locatioStreetUrl}`, { street: query});
        Promise.all([locatioPromise]).then(response => {
          context.suggestions = [];
          context.selected = null;
          context.suggestions = [ {data: response[0].data.results}];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.error(error, "Problem loading locatio, front-end show should nice client error");
          this.errors = [ "Unfortunately, we are having technical difficulties while looking up your address. You can try refreshing the page and trying again, or try again later." ];
        });
      }, context.debounceMilliseconds);
    },
    onInputChange(test){

      const context_value = {
        [test.target.name]                : test.target.value,
        [`${this.context.name}_cant_find`]: true,
      };
      this.context.model = Object.assign(this.context.model, context_value);

      this.getAlternativeAddress();
      
    },

    getAlternativeAddress() {
      // need three inputs to run this

      this.$delete(this.context.model,`${this.context.name}_displayed_address`);
      this.$delete(this.context.model,`${this.context.name}_displayed_locatio_id`);

      // this.context.model[`${this.context.name}_cant_find`];
      // this.context.model[`${this.context.name}_street_address`];
      // this.context.model[`${this.context.name}_street_locatio_id`];
      // this.context.model[`${this.context.name}_street_number`];
      // this.context.model[`${this.context.name}_flat_unit`];

      let unit       = this.context.model[`${this.context.name}_flat_unit`] ?? '';
      let number     = this.context.model[`${this.context.name}_street_number`] ?? '';
      let address_id = this.context.model[`${this.context.name}_street_locatio_id`] ?? '';

      if ( this.context.model[`${this.context.name}_cant_find`] && number !== '' && address_id !== '' ) {

        let context = this.nearAddress;

        clearTimeout(context.timeout);
        context.timeout = setTimeout(() => {

          let context = this.nearAddress;

          this.isLoading = true;
          this.errors = [];

          const locatioPromise = axios.post(`${locatioNearUrl}`, { 'unit': unit, 'number': number, 'address_id': address_id });
          Promise.all([locatioPromise]).then(response => {
            context.suggestions = [];
            context.suggestions = response[0].data.full_address.formatted

            // show full address, show address suggestions
            // this.$set(this.context.address, response[0].data.results[0].address_full);
            // context.address = response[0].data.results[0].address_full;
            // context.address = response[0].data.full_address.formatted;

            context.address = response[0].data.full_address.formatted;
            this.$set(this.context.model,`${this.context.name}_displayed_address`,response[0].data.full_address.formatted);
            this.$set(this.context.model,`${this.context.name}_displayed_locatio_id`,response[0].data.results[0].id);

            this.isLoading = false;
          }).catch(error => {
            this.isLoading = false;
            console.error(error, "Problem loading locatio, front-end show should nice client error");
            this.errors = [ "Unfortunately, we are having technical difficulties while looking up your address. You can try refreshing the page and trying again, or try again later." ];
          });
        }, context.debounceMilliseconds);
      }

    },

     /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */
    getSuggestionValue(suggestion) {
      return suggestion.item.address_full;
    },

    getSuggestionStreetValue(suggestion) {
      return suggestion.item.address_road_suburb_region;
    },

    onSelected(suggestion) {      
      // Store the data with a prefix of the name of the component 
      const context_value = { 
        [`${this.context.name}_full_address`]: suggestion.item.address_full,
        [`${this.context.name}_locatio_id`] : suggestion.item.id,
      };
      this.context.model = context_value;
      
      // this.$set(this.autocompleteSearch.inputProps, 'class', 'input is-success'); // needs more thought, and styling fixes
      
      this.selected = suggestion.item;
    },
    onStreetSelected(suggestion) {
      // delete this.context.model[`${this.context.name}_full_address`];
      // delete this.context.model[`${this.context.name}_locatio_id`];
      
      // Store the data with a prefix of the name of the component 
      const context_value = { 
        [`${this.context.name}_cant_find`]: true,
        [`${this.context.name}_street_address`]: suggestion.item.address_road_suburb_region,
        [`${this.context.name}_street_locatio_id`] : suggestion.item.id,
      };

      this.context.model = Object.assign(this.context.model, context_value);

      // this.context.model[`${this.context.name}_street_address`]    = suggestion.item.address_road_suburb_region;
      // this.context.model[`${this.context.name}_street_locatio_id`] = suggestion.item.id;


      // add valid to class
      this.$set(this.autocompleteStreet.inputProps, 'class', this.autocompleteStreet.inputProps.class + ' valid');


      this.selected = suggestion.item;

      this.getAlternativeAddress();

    }
  },
}
</script>

<style lang="scss">

.formulate-input-element--autocomplete {
    position: relative;
    .loader {
        position: absolute;
        margin-top: -30px;
        // right: 15px;
        left: -30px;
        display: none;
    }
}

.formulate-input-element--autocomplete.is-loading .loader {
    display: block;
}


#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 400px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

.results {
  border: 1px solid #e7f1ff;
  background: #f5ffff;
  border-radius: 4px;
  padding: 0.8rem 1rem;
}

div[name$=_full_address] {
  border: 1px solid #e7f1ff;
  background: #f5ffff;
  border-radius: 4px;
  padding: 0.8rem 1rem;
}

// custom error states

.formulate-input[data-is-showing-errors]:not([data-type="group"]) {

  [name$=_flat_unit] {
    // dont need error state
    color:#303030;
    border-color:#dfe3e8;

    &::placeholder {
      color:#717f86;
    }
  }

  [name$=_street_number].valid {
    border-color:#dfe3e8;
  }

  #autosuggest_street__input.valid {
    border-color:#dfe3e8;
  }

  #autosuggest__input {
    //color:none;

    &:disabled {
      // dont show error colours for these inputs
      color:#717f86;
      border-color:#dfe3e8;

      &::placeholder {
        color:#717f86;
      }
    }
  }
}

// input.disabled

// .formulate-input[data-is-showing-errors]:not([data-type="group"]) {
//   input, select {
    
//   }
// }

</style>